import React from 'react';
import { useTranslation } from '../../contexts/TranslationContext';
import { leagueLabel } from '../../constants/philipSnatLeagues';
import { DownloadIcon } from '../../assets/icons/DownloadIcon';

interface PredictionLeagueRowProps {
  league: string;
  games: number;
  onView: () => void;
  onDownload: () => void;
}

const PredictionLeagueRow: React.FC<PredictionLeagueRowProps> = ({ league, games, onView, onDownload }) => {
  const { t, language } = useTranslation();
  const plural = new Intl.PluralRules(language === 'pl' ? 'pl-PL' : 'en-US').select(games);
  const gamesLabel = (t.philipSnat.gamesCount as Record<string, string>)[plural] ?? t.philipSnat.gamesCount.other;

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.target !== event.currentTarget) return;
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onView();
    }
  };

  return (
    <div className="league-row" role="link" tabIndex={0} onClick={onView} onKeyDown={handleKeyDown}>
      <div className="league-row__info">
        <span className="league-row__name">{leagueLabel(league)}</span>
        <span className="league-row__games">{gamesLabel.replace('{count}', String(games))}</span>
      </div>
      <div className="league-row__actions">
        <button
          type="button"
          className="button_secondary league-row__download"
          aria-label={t.philipSnat.download}
          title={t.philipSnat.download}
          onClick={(event) => {
            event.stopPropagation();
            onDownload();
          }}
        >
          <DownloadIcon className="league-row__download-icon" />
        </button>
      </div>
    </div>
  );
};

export default PredictionLeagueRow;
